export default __webpack_public_path__ + "static/media/HomepplLogo.152f71d0.svg";